import Vue from 'vue';
import Vuex from 'vuex';

import * as actions from '@/store/actions';
import * as getters from '@/store/getters';

import app from '@/store/modules/app';
import widget from '@/store/modules/widget';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {},
    modules: {
        app,
        widget
    },
    getters,
    actions
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js